import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('cache', [
      'currentCompany'
    ]),

    companyBroadcastOpenDate () {
      return window.moment(this.companyDate.format('YYYY-MM-DD') + ' ' + this.currentCompany.broadcast_open)
    },

    companyBroadcastCloseDate () {
      return window.moment(this.companyDate.format('YYYY-MM-DD') + ' ' + this.currentCompany.broadcast_close)
    },

    broadcastOperatingHoursText () {
      return this.companyBroadcastOpenDate.format('h:mm A') + ' - ' + this.companyBroadcastCloseDate.format('h:mm A')
    },

    companyDate () {
      return window.moment(this.utcDate).tz(this.currentCompany.timezone)
    },

    utcDate () {
      return window.moment().tz('UTC')
    },

    companyTimezone () {
      return window.moment().tz(this.currentCompany.timezone)
    }
  },

  methods: {
    // Reads a date and time the user picked as company wall clock, whatever the browser's zone.
    // The formats are load-bearing: moment.tz() only keeps the wall clock when the string was
    // parsed with one. Without them the string falls back to new Date() and is read as an
    // instant, shifting the time by the browser's offset.
    companyDateTime (date, time) {
      return window.moment.tz(`${date} ${time}`, ['YYYY-MM-DD HH:mm', 'MM/DD/YYYY HH:mm'], this.currentCompany.timezone)
    },

    dateInCompanyTimezone (dt, format = 'MMM D, YYYY h:mm a z') {
      if (!dt) {
        return '-'
      }
      return window.moment.utc(dt).tz(this.currentCompany.timezone, true).format(format)
    }
  }
}
